import API from "../api/api";
import { filterActiveRecords } from "./activeDataUtils";

export const getHowItWorks = async () => {
    try {
        const response = await API.post("/howItWorks/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 10,
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        console.log("HowItWorks API Response:", response.data);
        return filterActiveRecords(response.data.data || []);
    } catch (error) {
        console.error("Error fetching howItWorks data:", error);
        throw error;
    }
};
